// Preset avatars + names. Files live under public/avatars/<name>.png.
// avatarSeed = file basename. Display name defaults to seed too, but the user can edit it.

import type { User } from './types'

const PRESETS = [
  'Gill Tan',
  'Hao233',
  'Huayong Ding',
  'Janice',
  'Jianing Xu',
  'Shirui',
  'Siyuan',
  'Yanshen',
  'Ye Lin',
  'Yinru',
  'Zhenan',
  'john',
  'zhouqi',
]

function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]
}

export function randomSeed(): string {
  return pick(PRESETS)
}

export function randomName(): string {
  return pick(PRESETS)
}

export function avatarUrl(seed: string, _size = 64): string {
  // Custom uploads come back as a path or absolute URL — pass through unchanged.
  if (seed.startsWith('/') || seed.startsWith('http')) return seed
  // Otherwise treat as preset filename. encodeURIComponent handles spaces.
  return `/avatars/${encodeURIComponent(seed)}.png`
}

export function isPresetSeed(seed: string): boolean {
  return PRESETS.includes(seed)
}

const DEFAULT_PRESET = 'Ye Lin'

export function listPresets(): string[] {
  return PRESETS.slice()
}

const KEY = 'flip:user:v2'

export function loadUser(): User {
  try {
    const raw = localStorage.getItem(KEY)
    if (raw) {
      const u = JSON.parse(raw) as User
      if (u.id && u.name && u.avatarSeed) return u
    }
  } catch {}
  const u: User = {
    id: crypto.randomUUID(),
    name: DEFAULT_PRESET,
    avatarSeed: DEFAULT_PRESET,
  }
  localStorage.setItem(KEY, JSON.stringify(u))
  return u
}

export function saveUser(u: User) {
  localStorage.setItem(KEY, JSON.stringify(u))
}
